import React, { ComponentProps } from 'react';
import { ChevronButton } from '@fiverr-private/button';
import { Center } from '@fiverr-private/layout_components';
import { ChevronDownIcon } from '@fiverr-private/visuals';
import { useCollapsibleContext } from '../CollapsibleContext';

interface CollapsibleHeaderChevronProps extends Pick<ComponentProps<typeof ChevronButton>, 'size' | 'theme'> {
  variant?: 'default' | 'lean';
}

const CollapsibleHeaderChevron = ({ size = 'xs', theme, variant = 'default' }: CollapsibleHeaderChevronProps) => {
  const { expanded, disabled } = useCollapsibleContext();

  return variant === 'default' ? (
    <ChevronButton
      size={size}
      shape="circle"
      chevronDirection={expanded ? 'up' : undefined}
      theme={theme}
      disabled={disabled}
    />
  ) : (
    <Center display="inlineFlex" as="span" transform={expanded ? 'rotate(-180deg)' : undefined} transition="0.15s">
      <ChevronDownIcon color="grey_1200" />
    </Center>
  );
};

CollapsibleHeaderChevron.displayName = 'CollapsibleHeaderChevron';
CollapsibleHeaderChevron.id = 'CollapsibleHeaderChevron';
export default CollapsibleHeaderChevron;
